export const textArray = [
    "Web Developer", 
    "Full-Stack Enthusiast", 
    "Problem Solver", 
    "Creative Thinker", 
    "Drummer 🥁", 
    "Runner 🥈", 
    "Hiker 🌄"
];